import React, { useMemo } from 'react';

import FormField from '@adsk/alloy-react-form-field/es/FormField';

import { PROJECT_TYPES_DATA } from '../../helpers/filters';
import i18n from '../../helpers/i18n';
import { SideFiltersType } from '../../hooks/useFilters';
import { HQAccount } from '../../models';
import { DropdownItemWithAvatar } from '../common/DropdownItemWithAvatar';
import { DropdownItemWithImage } from '../common/DropdownItemWithImage';
import { useAccessLevelContext } from '../Contexts/AccessLevelContext';
import { DateUrl } from '../Filters/DateUrl';
import { DropdownMultiSelectUrl } from '../Filters/DropdownMultiSelectUrl';

export type SideFiltersProps = {
  filters: SideFiltersType;
  onFilterChange: (filterKey: string, value?: string) => void;
};

const spaceStyle = { marginBottom: 24 };

export const SideFilters = ({ filters, onFilterChange }: SideFiltersProps) => {
  const { allAccounts } = useAccessLevelContext();

  const accounts = useMemo(
    () =>
      allAccounts.map((account: HQAccount) => ({
        value: account.id,
        label: account.name,
        imageUrl: account.imageUrl,
      })),
    [allAccounts],
  );

  return (
    <>
      <FormField
        label={i18n.t('ACCOUNT')}
        labelVariant={FormField.LABEL_VARIANTS.TOP}
        style={spaceStyle}
      >
        <DropdownMultiSelectUrl
          id="ProjectList_SideFilters_account"
          items={accounts}
          itemRenderer={DropdownItemWithImage}
          selectedValues={filters['account']}
          onChangeItem={(value) => onFilterChange('account', value)}
          placeholder={i18n.t('ACCOUNT_PLACEHOLDER') as string}
        />
      </FormField>
      <FormField
        label={i18n.t('PROJECT_TYPE')}
        labelVariant={FormField.LABEL_VARIANTS.TOP}
        style={spaceStyle}
      >
        <DropdownMultiSelectUrl
          id="ProjectList_SideFilters_project_type"
          items={PROJECT_TYPES_DATA}
          itemRenderer={DropdownItemWithAvatar}
          selectedValues={filters['project_type']}
          onChangeItem={(value) => onFilterChange('project_type', value)}
          placeholder={i18n.t('PROJECT_TYPE_PLACEHOLDER').toString()}
        />
      </FormField>
      <FormField
        label={i18n.t('CREATED_ON')}
        labelVariant={FormField.LABEL_VARIANTS.TOP}
        style={spaceStyle}
      >
        <DateUrl
          selectedValues={filters['created_on']}
          onChangeDate={(value) => onFilterChange('created_on', value)}
        />
      </FormField>
    </>
  );
};
